import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
var InfoBarMessageWithShowDetailsAction = /** @class */ (function (_super) {
    tslib_1.__extends(InfoBarMessageWithShowDetailsAction, _super);
    function InfoBarMessageWithShowDetailsAction(props) {
        var _this = _super.call(this, props) || this;
        _this.showDetails = function (evt) {
            evt.stopPropagation();
            _this.setState({ isShowingDetails: true });
        };
        _this.hideDetails = function (evt) {
            evt.stopPropagation();
            _this.setState({ isShowingDetails: false });
        };
        _this.state = { isShowingDetails: false };
        return _this;
    }
    InfoBarMessageWithShowDetailsAction.prototype.render = function () {
        var clickHandler = this.state.isShowingDetails ? this.hideDetails : this.showDetails;
        return (React.createElement("span", null,
            React.createElement("a", { className: this.props.className, onClick: clickHandler }, this.state.isShowingDetails
                ? this.props.hideDetailsText
                : this.props.showDetailsText),
            this.state.isShowingDetails && this.props.detailsElement));
    };
    InfoBarMessageWithShowDetailsAction = tslib_1.__decorate([
        observer
    ], InfoBarMessageWithShowDetailsAction);
    return InfoBarMessageWithShowDetailsAction;
}(React.Component));
export default InfoBarMessageWithShowDetailsAction;
//# sourceMappingURL=InfoBarMessageWithShowDetailsAction.js.map